import { render, staticRenderFns } from "./ComponentFinxTemplate.vue?vue&type=template&id=2cb049b0"
import script from "./ComponentFinxTemplate.vue?vue&type=script&lang=ts"
export * from "./ComponentFinxTemplate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports